module.exports = __webpack_public_path__ + "static/popupsmart-dev-fluid-d0f2f4b95174685128305f367a9c1612.png";